import { ArrayField, BooleanField, NumberField, SingleFieldList } from 'react-admin';

import { GetInstrumentOneResponse } from '@Common/types/bo/instruments';

import { ShowFields, ShowSection } from '@sh4res/bo-common/components';
import { CountriesStatusList } from '@sh4res/bo-common/components/Instruments/countries_status/CountriesStatusList';
import { LinkField } from '@sh4res/bo-common/fields';

export const StockSection = () => (
  <>
    <ShowSection label="resources.bo_common.instruments.sections.statuses">
      <ShowFields<GetInstrumentOneResponse & { country_settings: string }>
        fields={{
          tradable: <BooleanField data-testid="BoExternalStockSection_TradableField" />,
          fractionable: <BooleanField data-testid="BoExternalStockSection_FractionableField" />,
          is_price_fetched: (
            <BooleanField data-testid="BoExternalStockSection_IsPriceFetchedField" />
          ),
          is_enabled: <BooleanField data-testid="BoExternalStockSection_IsEnabledField" />,
          is_halted: <BooleanField data-testid="BoExternalStockSection_IsHaltedField" />,
          is_adr: <BooleanField data-testid="BoExternalStockSection_IsAdrField" />,
          is_etf: <BooleanField data-testid="BoExternalStockSection_IsEtfField" />,
          country_settings: <CountriesStatusList mode="list" />,
        }}
      />
    </ShowSection>
    <ShowSection label="resources.bo_common.instruments.sections.documents">
      <ShowFields<GetInstrumentOneResponse>
        fields={{
          kid_urls: (
            <ArrayField data-testid="BoExternalStockSection_KidUrlsArrayField">
              <SingleFieldList linkType={false}>
                <LinkField
                  source="language"
                  hrefSource="url"
                  data-testid="BoExternalStockSection_KidUrlsLinkField"
                />
              </SingleFieldList>
            </ArrayField>
          ),
        }}
      />
    </ShowSection>
    <ShowSection label="resources.bo_common.instruments.sections.other">
      <ShowFields<GetInstrumentOneResponse>
        fields={{
          shares_ca_wht_rate_at_source: (
            <NumberField data-testid="BoExternalStockSection_SharesCaWhtRateAtSourceField" />
          ),
          five_year_beta: <NumberField data-testid="BoExternalStockSection_FiveYearBetaField" />,
          five_year_beta_fallback: (
            <NumberField data-testid="BoExternalStockSection_FiveYearBetaFallbackField" />
          ),
        }}
      />
    </ShowSection>
  </>
);
